import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { map,filter, pluck } from 'rxjs/operators';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from "rxjs";
import { LocalService } from '../../storage/localService';

@Injectable({
  providedIn: 'root'
})
export class ProformaService {
  datosProforma: any;
  datosPropuestaInformacion:any;
  flagEvaluacion:boolean;
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  idEmpresa_Factor: any;
  message: Observable<any>;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  ObtenerListaProforma(rucProv: string, RucAqd: string, Tipo_Operacion: string, FInicial?: any, FFinal?: any) { // ACTUALIZAR API A PREPROD
    
    let headers = this.header;
    return this.http.get(`${this.urlBase}/DocumentosAsociados?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion_Prov=${rucProv}&Num_Doc_Identificacion_ADQ=${RucAqd}&Tipo_Operacion=${Tipo_Operacion}`, {headers}); 
  
   }

  obtenerTEM(body: any, IDEMPRESA: number) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/TEMProforma?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  ObtenerDocumentosNegociables(body: any) { // ACTUALIZAR API A PREPROD
    let headers = this.header;
    return this.http.get(`${this.urlBase}/DocumentosNegociables?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&Tipo_Comprobante=${body.Tipo_Comprobante}&Moneda=${body.Moneda}&Num_Doc_Identificacion_Prov=${body.Num_Doc_IdentificacionProv}&Num_Doc_Identificacion_ADQ=${body.Num_Doc_IdentificacionADQ}&Tipo_Operacion=${body.Tipo_Operacion}`,{headers});   
  }

  obtenerRanking(RUC_ADQ) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Top10K?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion_ADQ=${RUC_ADQ}`, { headers });
  }

  CrearProforma(body: any) {    
    let headers = this.header;
    return this.http.post(`${this.urlBase}/Proforma?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  TraspasarInversion(body: any) {    
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `chxgyefNFte69U7GvdWkjAfLbuPLzh`);
    return this.http.post(`https://operacion-dot-starkengine.ue.r.appspot.com/api-operacion/traspasarInversiones?idEmpresa_Factor=${this.idEmpresa_Factor}`, body,{headers});  
   
  }  
  RetirarSaldo(body: any) {    
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `chxgyefNFte69U7GvdWkjAfLbuPLzh`);
    return this.http.post(`https://operacion-dot-starkengine.ue.r.appspot.com/api-operacion/retirarInversiones?idEmpresa_Factor=${this.idEmpresa_Factor}`, body,{headers});  
   
  }  
  DepositarSaldo(body: any) {    
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `chxgyefNFte69U7GvdWkjAfLbuPLzh`);
    return this.http.post(`https://operacion-dot-starkengine.ue.r.appspot.com/api-operacion/depositarInversiones?idEmpresa_Factor=${this.idEmpresa_Factor}`, body,{headers});  
   
  }  
  
  enviarProformaProv(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/NotificarCliente?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  factoring(body: any, IDEMPRESA: number) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/FactoringProformaCalc?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  factoringResume(body: any, IDEMPRESA: number) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CalcularComision?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }


  obtenerProformas(rucADQ: string, rucProv: string, estado: string, fechaDop: any, fechaHop: any,user:string) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Proforma?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion_ADQ=${rucADQ}&Num_Doc_Identificacion_Prov=${rucProv}&Estado=${estado}&cDesdeOp=${fechaDop}&cHastaOp=${fechaHop}&User=${user}`, { headers });
  }

  obtenerProforma(idProforma: number) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ProformaxID?idEmpresa_Factor=${this.idEmpresa_Factor}&idProforma=${idProforma}`, { headers })
      .pipe(map(res => { return res[0] }));
  }

  obtenerProformaDetalle(idProforma: number) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ProformaDetallexID?idEmpresa_Factor=${this.idEmpresa_Factor}&idProforma=${idProforma}`, { headers });   
  }

  obtenerProformaOperacion() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ProformaOperacion?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  actualizarProforma(body: any) { 
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ActualizarProforma?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});     
  }

  bajaProforma(body: any) { // SE USA ????
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ActualizarProforma?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }
}